import React from "react";
import PostItem from "./PostItem.js";
import Posts from "./posts.json";

const PostList = () => {
  return(
      <>
        <div className={`list-group`}>
          {
            Posts.map(post => {
              return (
                  <PostItem post={post}/>
              );
            })
          }
        </div>
      </>
  )
}

export default PostList;